import React, { useState } from 'react';
import { ArrowUp, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  return <>
      <footer className="bg-[#F5F5FA] py-12 border-t border-[#E0E7FF]" data-id="element-178">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-180">
            <div className="text-center md:text-left" data-id="element-181">
              <h4 className="font-bold text-[#1E1B4B] mb-2" data-id="element-182">
                7 Signals Reset™
              </h4>
              <p className="text-sm text-[#78716C]" data-id="element-183">
                Not medical advice. For educational purposes only.
              </p>
            </div>
            <button onClick={scrollToTop} className="flex items-center text-sm font-medium text-[#4338CA] hover:text-[#4F46E5] transition-colors" data-id="element-184">
              Back to top
              <ArrowUp className="w-4 h-4 ml-2" data-id="element-185" />
            </button>
          </div>
          <div className="mt-8 pt-8 border-t border-[#E0E7FF] flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-186">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-[#78716C] hover:text-[#4338CA] transition-colors" data-id="element-187">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-[#78716C] hover:text-[#4338CA] transition-colors" data-id="element-188">
              Terms & Conditions
            </button>
          </div>
          <div className="mt-6 text-center text-xs text-[#A8A29E]" data-id="element-189">
            © {new Date().getFullYear()} 7 Signals Reset. All rights reserved.
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-190">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={closeModal} data-id="element-191">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-192">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-193">
                <h2 className="text-xl font-bold text-[#1E1B4B]" data-id="element-194">
                  {activeModal === 'privacy' && 'Privacy Policy'}
                  {activeModal === 'terms' && 'Terms & Conditions'}
                </h2>
                <button onClick={closeModal} className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-195">
                  <X className="w-5 h-5 text-gray-500" data-id="element-196" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[60vh] text-sm text-[#44403C] space-y-4" data-id="element-197">
                <p data-id="element-198">Standard legal text placeholder for {activeModal}.</p>
              </div>
              <div className="p-6 border-t border-gray-100 bg-gray-50" data-id="element-199">
                <button onClick={closeModal} className="w-full py-3 px-4 bg-[#4338CA] text-white font-semibold rounded-xl hover:bg-[#4F46E5] transition-colors" data-id="element-200">
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}